import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/naslov.css';

// Add CSS for mobile responsive footer
const footerStyles = `
  @media (max-width: 768px) {
    .footer-contact-info {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 0.5rem !important;
      font-size: 0.9rem !important;
    }
    
    .footer-payment-info {
      display: grid !important;
      grid-template-columns: auto 1fr !important;
      gap: 0.3rem !important;
      margin-bottom: 0.3rem !important;
      font-size: 0.9rem !important;
    }
    
    .footer-payment-info .payment-item {
      white-space: normal !important;
      flex-shrink: 0 !important;
    }
    
    .footer-payment-info .payment-item:nth-child(3),
    .footer-payment-info .payment-item:nth-child(4) {
      grid-column: 1 / -1 !important;
    }
    
    .footer-top-nav {
      padding: 1rem 0 !important;
    }
    
    .footer-top-nav .container > div {
      gap: 0.5rem !important;
    }
    
    .footer-top-nav a {
      font-size: 0.8rem !important;
      padding: 0.3rem 0.7rem !important;
    }
    
    .footer-middle {
      padding: 1rem 0 !important;
    }
    
    .footer-middle .container > div {
      gap: 1.5rem !important;
    }
    
    .footer-logo {
      width: 60px !important;
      height: 60px !important;
    }
    
    .footer-business-info {
      font-size: 0.9rem !important;
      line-height: 1.6 !important;
      text-align: center !important;
    }
    
    .footer-business-info > div:first-child {
      font-size: 1rem !important;
      margin-bottom: 0.5rem !important;
    }
    
    .footer-copyright {
      padding-top: 0.5rem !important;
      margin-top: 0.5rem !important;
    }
    
    .footer-copyright p {
      font-size: 0.8rem !important;
    }
  }
  @media (min-width: 769px) {
    .footer-contact-info {
      flex-direction: row !important;
      align-items: center !important;
      gap: 1rem !important;
      justify-content: center !important;
    }
  }
`;

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleNavigation = (path) => {
    navigate(path);
    // Force scroll to top for Firefox
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
  };

  return (
    <>
      <style>{footerStyles}</style>
      <footer className="main-footer" style={{
        background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
        borderTop: '1px solid #e5e7eb',
        padding: '0',
        position: 'relative',
        overflow: 'hidden'
      }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
          radial-gradient(circle at 20% 20%, rgba(0, 114, 206, 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 80%, rgba(0, 195, 0, 0.03) 0%, transparent 50%)
        `,
        pointerEvents: 'none'
      }}></div>

      {/* TOP NAVIGATION BAR */}
      <div className="footer-top-nav" style={{
        padding: '2rem 0',
        borderBottom: '1px solid #e5e7eb',
        position: 'relative',
        zIndex: 1
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1rem',
            flexWrap: 'wrap'
          }}>
            <Link 
              to="/" 
              style={{
                color: isActive('/') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/') ? 'rgba(0, 114, 206, 0.1)' : 'transparent'
              }}
            >
              Početna
            </Link>
            <Link 
              to="/instrukcije" 
              style={{
                color: isActive('/instrukcije') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/instrukcije') ? 'rgba(0, 114, 206, 0.1)' : 'transparent'
              }}
            >
              Instrukcije
            </Link>
            <button 
              onClick={() => handleNavigation('/skripte')}
              style={{
                color: isActive('/skripte') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/skripte') ? 'rgba(0, 114, 206, 0.1)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              Skripte
            </button>
            <Link 
              to="/faq" 
              style={{
                color: isActive('/faq') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/faq') ? 'rgba(0, 114, 206, 0.1)' : 'transparent'
              }}
            >
              FAQ
            </Link>
            <button 
              onClick={() => handleNavigation('/kontakt')}
              style={{
                color: isActive('/kontakt') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/kontakt') ? 'rgba(0, 114, 206, 0.1)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit'
              }}
            >
              Kontakt
            </button>
            <Link 
              to="/pravila-privatnosti" 
              style={{
                color: isActive('/pravila-privatnosti') ? '#0072CE' : '#374151',
                textDecoration: 'none',
                fontWeight: '600',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                transition: 'all 0.3s ease',
                padding: '0.5rem 1rem',
                borderRadius: '8px',
                background: isActive('/pravila-privatnosti') ? 'rgba(0, 114, 206, 0.1)' : 'transparent'
              }}
            >
              Pravila Privatnosti
            </Link>
          </div>
        </div>
      </div>

      {/* MIDDLE SECTION - LOGO AND BUSINESS INFO */}
      <div className="footer-middle" style={{
        padding: '1.5rem 0',
        borderBottom: '1px solid #e5e7eb',
        position: 'relative',
        zIndex: 1
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '3rem',
            flexWrap: 'wrap'
          }}>
            {/* BUSINESS INFORMATION */}
            <div className="footer-business-info" style={{
              color: '#374151',
              fontSize: '1rem',
              lineHeight: '1.8',
              maxWidth: '800px'
            }}>
              {/* Payment info with responsive flex */}
              <div className="footer-contact-info footer-payment-info" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '1rem',
                marginBottom: '0.3rem',
                flexWrap: 'wrap'
              }}>
                <div className="payment-item" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-university" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  PBZ d.d. 
                </div>
                <div className="payment-item" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-exchange-alt" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  SWIFT: PBZGHR2X
                </div>
                <div className="payment-item" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-credit-card" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  IBAN: HR7223400093113309963
                </div>
                <div className="payment-item" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-id-card" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  OIB: 98978576142
                </div>
              </div>
              <div style={{ marginBottom: '0.3rem', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                <strong>Obrt za instrukcije i poduke</strong>, vl. Marko Pačalat
              </div>
              {/* Contact info with responsive flex */}
              <div className="footer-contact-info" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '1rem',
                marginBottom: '0.3rem'
              }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-envelope" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  konto.zona@gmail.com
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-map-marker-alt" style={{ color: '#0072CE', marginRight: '0.5rem' }}></i>
                  Diljska ulica 26, Zagreb, Hrvatska
                </div>
              </div>
            </div>

            {/* LOGO */}
            <div className="footer-logo" style={{
              width: '100px',
              aspectRatio: '1 / 1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              position: 'relative',
              backgroundColor: 'white',
              borderRadius: '50%',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
              padding: '10px'
            }}>
              <img 
                src="/kontozona-logo.png" 
                alt="Konto Zona Logo" 
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                }}
              />
            </div>
          </div>
        </div>
        
        {/* Copyright at bottom of footer */}
        <div className="footer-copyright" style={{
          textAlign: 'center',
          paddingTop: '1rem',
          marginTop: '1rem'
        }}>
          <p style={{
            color: '#6B7280',
            fontSize: '0.9rem',
            margin: 0,
            fontWeight: '500'
          }}>
            Copyright © 2025 Konto Zona - Sva prava pridržana
          </p>
        </div>
      </div>


    </footer>
    </>
  );
};

export default Footer; 